// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createSlice } from '@reduxjs/toolkit';

import { addAsyncCases, updateStateStatus } from '../utils/utils';

import {
  fetchCompanyScenes,
  fetchSceneById,
  addKeywordToScene,
  deleteKeywordFromScene,
  filteredScenes,
  localFilterScenes,
  fetchUnrealVersion,
} from './scenesActions';

import {
  filterScenesState,
  localFilterScenesState,
  addKeywordToSceneState,
  deleteKeywordFromSceneState,
} from './scenesReducers';

const initialState = {
  scenes: [],
  selectedScene: null,
  filterScenes: {
    scenes: [],
    providers: [],
    title: null,
    sortOrder: 'desc',
  },
  unrealVersions: [],
  status: {
    // possible status state : 'idle' | 'loading' | 'succeeded' | 'failed'
    scenes: 'idle',
    filterScenes: 'idle',
  },
  error: {
    scenes: null,
    filterScenes: null,
  },
};

const sceneSlice = createSlice({
  name: 'scenes',
  initialState,
  reducers: {
    clearError: state => {
      state.error = initialState.error;
    },
    clearFilteredList: state => {
      state.filterScenes = {
        ...state.filterScenes,
        scenes: [],
        providers: [],
        title: null,
      };
      state.error.filterScenes = null;
    },
    clearSelectedScene: state => {
      state.selectedScene = null;
    },
    setSelectedScene: (state, action) => {
      state.selectedScene = action.payload;
    },
  },
  extraReducers: builder => {
    addAsyncCases(builder, [
      { action: fetchCompanyScenes, key: 'scenes' },
      { action: fetchSceneById, key: 'selectedScene' },
      { action: fetchUnrealVersion, key: 'unrealVersions' },
    ]);
    builder
      .addCase(filteredScenes.fulfilled, (state, action) => {
        filterScenesState(state, action.payload);
        updateStateStatus(state, 'filterScenes', 'succeeded');
      })
      .addCase(localFilterScenes.pending, state => {
        updateStateStatus(state, 'filterScenes', 'loading');
      })
      .addCase(localFilterScenes.fulfilled, (state, action) => {
        localFilterScenesState(state, action.payload);
        updateStateStatus(state, 'filterScenes', 'succeeded');
      })
      .addCase(localFilterScenes.rejected, (state, action) => {
        updateStateStatus(state, 'filterScenes', 'failed', action);
      })
      .addCase(addKeywordToScene.fulfilled, (state, action) => {
        addKeywordToSceneState(state, action.payload);
        updateStateStatus(state, 'scenes', 'succeeded');
      })
      .addCase(deleteKeywordFromScene.fulfilled, (state, action) => {
        deleteKeywordFromSceneState(state, action.payload);
        updateStateStatus(state, 'scenes', 'succeeded');
      });
  },
});

export const { clearError, clearFilteredList, clearSelectedScene, setSelectedScene } =
  sceneSlice.actions;

export const scenesStatus = state => state.scenes.status;
export const scenesError = state => state.scenes.error;

export default sceneSlice.reducer;
